/*=========================================================================================
  File Name: module-auth.js
  Description: Auth Module
  ----------------------------------------------------------------------------------------
  Project: MISA MTAX WebApp
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/

import state from "./module-report-state";
import mutations from "./module-report-mutations";
import actions from "./module-report-actions";
import getters from "./module-report-getters";

export default {
  debug: import.meta.env.PROD,
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters,
};
